import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/templates/[slug]/TemplatePreview.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/ClientReels.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/homepage/styles/homepage.css");
;
import(/* webpackMode: "eager", webpackExports: ["TemplateGrid"] */ "/vercel/path0/src/components/homepage/TemplateShowcase.tsx");
